import moment from "moment";

/**
 * Wire format for the endpoints that validate a date with `date_format:d-m-Y`
 * (appointment scheduling, the patient intake lookup, Skyflow validation and
 * the document share expiry).
 */
export const API_DATE_FORMAT = "DD-MM-YYYY";

/**
 * Format the date pickers show, which is what the "yyyy-mm-dd" helper text
 * printed under every one of those fields promises.
 */
export const DISPLAY_DATE_FORMAT = "YYYY-MM-DD";

/**
 * Parse a date written in either format. The two are never ambiguous: the
 * four digit group can only be the year, and it sits at opposite ends.
 */
const parseDate = (value) => {
	if (!value) return null;
	if (moment.isMoment(value)) return value.isValid() ? value : null;
	if (value instanceof Date) {
		const fromDate = moment(value);
		return fromDate.isValid() ? fromDate : null;
	}

	const parsed = moment(String(value).trim(), [DISPLAY_DATE_FORMAT, API_DATE_FORMAT], true);
	return parsed.isValid() ? parsed : null;
};

/** Format a picker value for the API. Returns "" when there is nothing to send. */
export const toApiDate = (value = "") => parseDate(value)?.format(API_DATE_FORMAT) || "";

/** Format an API value for the picker. Returns "" when there is nothing to show. */
export const fromApiDate = (value = "") => parseDate(value)?.format(DISPLAY_DATE_FORMAT) || "";
